module.exports = __webpack_public_path__ + "static/media/ill-prime@2x.eff3aab6.png";